import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { clsx } from 'clsx';
import { FOKUS_RING_ABGESETZT } from '@/lib/fokus';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  children: ReactNode;
};

const VARIANTS: Record<Variant, string> = {
  primary:
    'bg-akzent text-cream hover:bg-akzent-stark disabled:bg-ink-faint disabled:text-cream',
  secondary: 'bg-cream-dark text-ink hover:bg-gold-soft disabled:text-ink-faint',
  ghost:
    'bg-transparent text-ink-soft hover:bg-cream-dark hover:text-ink disabled:text-ink-faint',
  danger: 'bg-coral text-cream hover:bg-coral/90 disabled:bg-ink-faint disabled:text-cream'
};

// Touch-Ziel mindestens 44 Pixel hoch (CLAUDE.md) — als `min-h` gesetzt
// und nicht aus Polsterung plus Zeilenhoehe gerechnet. Die Rechnung stand
// hier frueher als Behauptung im Kommentar; nachgemessen im laufenden
// Build waren es 40 Pixel.
// active:scale fuer Press-Feedback.
export function Button({ variant = 'primary', className, children, ...rest }: ButtonProps) {
  return (
    <button
      {...rest}
      className={clsx(
        'inline-flex min-h-[44px] items-center justify-center gap-2 rounded-md px-4 py-2.5 font-medium transition-colors',
        `${FOKUS_RING_ABGESETZT}`,
        // Deaktiviert muss auf einen Blick von "sekundaer" zu
        // unterscheiden sein (B66/B74): ausgegraut, blass, kein
        // Press-Feedback und kein Hover.
        'active:scale-[0.98] disabled:cursor-not-allowed',
        'disabled:opacity-50 disabled:shadow-none disabled:active:scale-100',
        VARIANTS[variant],
        className
      )}
    >
      {children}
    </button>
  );
}
